export default {"src":"/_next/static/media/shield-star.886d0574.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};